import React, { Component, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SecureLoadingContent from 'components/components/common/SecureLoadingContent';
import withRouter from 'components/components/common/withRouter';
import { connect } from 'react-redux';
import {
  fetchPriceList,
  fetchCustomerAddresses,
  fetchBusStops
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';
import { PatternFormat } from 'react-number-format';
import { setUserLogout } from 'components/actions/authActions';
import LocalStorageHelper from 'components/common/helpers/LocalStorageHelper';
import AppLink from 'components/common/AppLink';
import originAxios from 'axios';

const MenuItem = ({ link, fa_cat = 'fas', fa_name, name }) => (
  <li className="list-border__item">
    <AppLink to={link}>
      <FontAwesomeIcon
        icon={[`${fa_cat}`, `${fa_name}`]}
      />
      {name}
      <FontAwesomeIcon
        icon={['fas', 'angle-right']}
      />
    </AppLink>
  </li>
);

class Account extends Component {

  state = {
    redirect: false
  }

  componentDidMount() {
    this.props.fetchPriceList();
    this.props.fetchCustomerAddresses();
    this.props.fetchBusStops();
  }

  setRedirect = () => {
    this.setState({
      redirect: true
    });
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      var url = TransHelper.translateRoute(this.props.locale, 'routes.url.accountProfile');
      return <Redirect to={url} />;
    }
  }

  trans = (key, pref = "content.account") => {
    return TransHelper.translate(this.props.locale, pref + "." + key);
  }

  logoutUser = (event) => {
    event.preventDefault();
    originAxios.post('/unset-logged').then(response => {
      LocalStorageHelper.removeToken();
      this.props.setUserLogout();
      TransHelper.redirect(this.props, 'routes.url.home');
    });
  }

  render() {
    const { customer } = this.props;

    return (
      <SecureLoadingContent softLoading >
        <div className="content" style={{ padding: '0' }}>

          <div className="grid-layout grid-layout--height-auto" style={{ padding: '0' }}>
            <div className="grid-layout__item grid-layout__item--edit">

              <div className="user-profile-container">
                <div className="user-profile">
                  <div className="user-name">
                    <p>{customer.name}</p>
                  </div>

                  <ul className="user-info">
                    <li className="user-info__item">
                      <p>
                        <FontAwesomeIcon
                          icon={['fas', 'envelope']}
                        />
                        {customer.email}
                      </p>
                    </li>

                    <li className="user-info__item">
                      <p>
                        <FontAwesomeIcon
                          icon={['fas', 'mobile-alt']}
                        />

                        {/*
                          norway: "(+##) ## ## ##"
                          poland: "(+##) ### ### ###"
                        */}
                        <PatternFormat
                          displayType={'text'}
                          format="(+##) ### ### ###"
                          value={customer.phone} />
                      </p>
                    </li>

                    <li className="user-info__item user-info__item--pass">
                      <p>
                        <FontAwesomeIcon
                          icon={['fas', 'lock']}
                        />
                        <span>*****</span></p>
                    </li>
                  </ul>
                </div>
              </div>

              {this.renderRedirect()}
              <button
                className="button button--edit"
                onClick={this.setRedirect}
                title={TransHelper.translate(this.props.locale, 'content.account.editProfileTitle')}
              >
                <FontAwesomeIcon
                  icon={['fas', 'pencil-alt']}
                  size="lg"
                />
              </button>
            </div>

            <div className="grid-layout__item grid-layout__item--desc grid-layout__item--center grid-layout__item--no-shadow">

              <div className="content__desc">
                <ul className="list-border">
                  <MenuItem
                    fa_name="calendar-alt"
                    name={this.trans('menu.myTrips')}
                    link="routes.url.accountTrips" />
                  <MenuItem
                    fa_name="credit-card"
                    name={this.trans('menu.cards')}
                    link="routes.url.accountCards" />
                  {/* <MenuItem
                    fa_name="map-marker"
                    name={this.trans('menu.places')}
                    link="routes.url.accountPlaces" /> */}
                  <MenuItem
                    fa_name="file-invoice"
                    name={this.trans('menu.invoices')}
                    link="routes.url.accountInvoices" />
                  <MenuItem
                    fa_name="cog"
                    name={this.trans('menu.settings')}
                    link="routes.url.accountSettings" />
                  <li className="list-border__item">
                    <Link
                      onClick={this.logoutUser}
                      to={""}
                      className="link-sign-out">
                      <FontAwesomeIcon
                        icon={['fas', 'sign-out-alt']}
                      />
                      {this.trans('settings.logout')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </SecureLoadingContent>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customer: state.auth.customer,
    locale: state.app.locale,
    isLogged: state.auth.isLogged
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    { fetchPriceList, fetchCustomerAddresses, fetchBusStops, setUserLogout }
  )(Account)
);
